import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class OrderAddressZipCodeInvalidError extends Violation {
	public constructor() {
		super(ViolationSeverity.Error, 'data-model.orders.address.validation.zip-code.pattern');
	}
}
